<template>
    <div class="box-shadow-settings">
        <table >
            <thead v-if="styleJSON.boxShadow.shadows.length>0">
                <tr class="text-center" style="font-size:12px;background:whitesmoke">
                    <td>inset</td>
                    <td>x</td>
                    <td>y</td>
                    <td>o</td>
                    <td>r</td>
                    <td>цвет</td>
                    <td></td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(shadow, index) in styleJSON.boxShadow.shadows">
                    <td>
                        <inputi type="boolean" :value='shadow.i' @input="(i)=>{setShadow(index,{i})}" />
                    </td>
                    <td>
                        <drag-input :value='shadow.x' @input="(x)=>{setShadow(index,{x})}" />
                    </td>
                    <td>
                        <drag-input :value='shadow.y' @input="(y)=>{setShadow(index, {y})}" />
                    </td>
                    <td>
                        <drag-input :value='shadow.r' @input="(r)=>{setShadow(index, {r})}" />
                    </td>
                    <td>
                        <drag-input :value='shadow.o' @input="(o)=>{setShadow(index, {o})}" />
                    </td>
                    <td>
                        <color-picker :label="'Цвет тени '+(index+1)" :color="shadow.color" @input="(color)=>{setShadow(index, {color})}" />
                    </td>
                    <td>
                        <btn icon="trash-alt" t="d" s="s" @press="removeShadow(index)" />
                    </td>
                </tr>
                <tr>
                	<td colspan="6" class="text-center">
                		<btn icon="plus" t="p" s="s" @press="addShadow" label="Добавить тень"/>
                	</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    name: "box-shadow-settings",
    props: ["styleJSON", "setStyle"],
    methods: {
        setShadow(index, props) {
            let { styleJSON } = this;
            let shadows = [...styleJSON.boxShadow.shadows];
            shadows[index] = Object.assign({}, shadows[index], props);
            this.setStyle({ boxShadow: { shadows } });
        },
        addShadow() {
            let { shadows } = this.styleJSON.boxShadow;
            this.setStyle({ boxShadow: { shadows: [...shadows, { i: false, x: 1, y: 1, o: 0, r: 1, color: 'grey' }] } });
        },
        removeShadow(shadowIndex) {
            let { shadows } = this.styleJSON.boxShadow;
            this.setStyle({ boxShadow: { shadows: shadows.filter((shadow,index)=>{
            	if(index === shadowIndex) return false;
            	else return true;
            }) } });
        }
    }
}
</script>
<style scoped>
.drag-input {
    width: 20px;
    text-align: center;
}
table{
	border-collapse:collapse;
	border-radius: 5px;
	width:100%;
}
table td{
	border:1px solid lightgrey;
}

</style>